// extracted by mini-css-extract-plugin
module.exports = {"DealEditorFooter":"DealEditorFooter_DealEditorFooter__UHbk5","SaveButton":"DealEditorFooter_SaveButton__rsDp1","Icon":"DealEditorFooter_Icon__aAC8V"};